// Cookieless first-party visit counter. Sent for every visitor regardless of the cookie choice: no identifier is
// stored in the browser and the server only keeps a daily-rotating hash (see deploy/gtm/README.md).
export const visitEndpoint = '/api/metrics';
const utmKeys = ['utm_source', 'utm_medium', 'utm_campaign'];

export function buildVisitPayload({ href, referrer, event = 'page_view', detail } = {}) {
  let url;
  try { url = new URL(href); } catch { return null; }
  const payload = { event, path: url.pathname, locale: /^\/tr(\/|$)/.test(url.pathname) ? 'tr' : 'en', referrer: referrer || null };
  const utm = {};
  for (const key of utmKeys) { const value = url.searchParams.get(key); if (value) utm[key] = value; }
  if (Object.keys(utm).length) payload.utm = utm;
  if (detail) payload.detail = String(detail).slice(0, 60);
  return payload;
}

export function sendVisit(payload, { beacon, fetchImpl } = {}) {
  if (!payload) return false;
  const body = JSON.stringify(payload);
  const sendBeacon = beacon || (globalThis.navigator?.sendBeacon ? globalThis.navigator.sendBeacon.bind(globalThis.navigator) : null);
  try { if (sendBeacon && sendBeacon(visitEndpoint, new Blob([body], { type: 'application/json' }))) return true; } catch {}
  const doFetch = fetchImpl || globalThis.fetch;
  if (!doFetch) return false;
  try {
    const result = doFetch(visitEndpoint, { method: 'POST', headers: { 'content-type': 'application/json' }, body, keepalive: true });
    if (result && typeof result.catch === 'function') result.catch(() => {});
    return true;
  } catch { return false; }
}

// One page view per URL per page load. Called on every consent evaluation, so it dedupes on the current URL.
export function recordPageView(win = globalThis.window, transport) {
  const href = win?.location?.href;
  if (!href || win.__palmateVisitRecorded === href) return false;
  win.__palmateVisitRecorded = href;
  return sendVisit(buildVisitPayload({ href, referrer: win.document?.referrer || globalThis.document?.referrer }), transport);
}

export function recordVisitEvent(event, detail, win = globalThis.window, transport) {
  const href = win?.location?.href;
  if (!href) return false;
  return sendVisit(buildVisitPayload({ href, referrer: win.document?.referrer || globalThis.document?.referrer, event, detail }), transport);
}
